import axios from 'axios';

export async function getDomain (domain) {
  try {
    let { data } = await axios.get(`https://thesendingdomain.com/domains?domain=${domain}`);
    return data;
  } catch (e) {
    console.log(e);
  }
}